import { render, staticRenderFns } from "./VLogoCarteiroDigital.vue?vue&type=template&id=1968ec8b&scoped=true"
import script from "./VLogoCarteiroDigital.vue?vue&type=script&lang=js"
export * from "./VLogoCarteiroDigital.vue?vue&type=script&lang=js"
import style0 from "./VLogoCarteiroDigital.vue?vue&type=style&index=0&id=1968ec8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968ec8b",
  null
  
)

export default component.exports